import React, { useState } from 'react';
import Stack from '@clasohlson/co-ui-components/Stack';
import { hexToRGB } from '@clasohlson/co-ui-components/utils/helpers';
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-google-places-autocomplete';
// If you want to use the provided css
// import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CustomButton } from '../button/CustomButton';
// import i18n from '../../i18n';
import { getCountryCodeFromUrl, useTranslation } from '../../utils';
// import { CustomTextfield } from '../textfield/CustomTextfield';

const PlacesWrapper = styled.div`
  width: 100%;
  position: relative;
  input {
    width: 100%;
    height: 38px;
    line-height: 38px;
    border: solid 1px #d9d5d5;
    font-size: 12px;
    padding: 0 0.75rem;
    &:focus {
      border: 1px solid #2d8ac0;
      outline: 1px solid #78d7fa;
    }
  }
  .google-places-autocomplete__suggestions-container {
    background: #fff;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    z-index: 5;
    max-height: 300px;
    overflow: auto;
    box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.09);
    border: solid 1px #d9d5d5;
    .google-places-autocomplete__suggestion {
      padding: 0.75rem;
      border-bottom: 1px solid #d9d5d5;
      cursor: pointer;
      font-size: 14px;
      &:hover {
        background: ${hexToRGB('#2d8ac0', 0.05)};
      }
    }
    @media screen and (max-width: 640px) {
      position: relative;
      max-height: 200px;
    }
  }
`;

export const FindStores = () => {
  const [city, setCity] = useState<any>();
  const { t } = useTranslation();
  const country = getCountryCodeFromUrl();

  const handleResult = async (data: any) => {
    try {
      const res = await geocodeByAddress(data.description);
      const latlng = await getLatLng(res[0]);
      setCity({ city: data.description, ...latlng });
      // console.log(res, latlng);
    } catch (e) {
      console.error(e);
    }

    // .then((results) => getLatLng(results[0]))
    // .then(({ lat, lng }) => console.log('Successfully got latitude and longitude', { lat, lng }));
  };
  const handleSubmit = () => {
    if (city) {
      window.location.href = `https://www.clasohlson.com/${country}/store-finder?q=${city.city}&source=careof&latitude=${city.lat}&longitude=${city.lng}`;
    }
  };
  const restrictedCountries: string[] = ['se', 'fi', 'no'];
  return (
    <Stack spacing="medium" alignItems="stretch">
      {/* <CustomTextfield
        label={t('searchStoreLabel')}
        placeholder={t('searchStoreLabel')}
        hideLabel
        fullWidth
        value={city}
        onChange={(e: any) => setCity(e.currentTarget.value)}
      /> */}
      <PlacesWrapper>
        <GooglePlacesAutocomplete
          placeholder={t('searchStoreLabel')}
          onSelect={handleResult}
          apiKey={process.env.GOOGLE_API_KEY}
          autocompletionRequest={{
            // @ts-ignore
            componentRestrictions: { country: restrictedCountries },
          }}
        />
      </PlacesWrapper>
      <CustomButton
        style={{ width: '100%' }}
        fullWidth
        onClick={() => handleSubmit()}
        disabled={!city}
      >
        {t('searchStoreButton')}
      </CustomButton>
    </Stack>
  );
};
